module.exports = __webpack_public_path__ + "static/media/entertainment.47035044.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/categories/entertainment.png
// module id = 489
// module chunks = 0